<template>
  <div class="infoMessageMain">
    <div class="infoMessage">
      {{ interpretedInfoMessage(message) }}
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'

export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  mixins: [messageMixin]
}
</script>

<style scoped>
.infoMessageMain {
  display: flex;
  justify-content: center;
}

.infoMessage {
  background-color: rgb(255, 251, 199);
  font-size: 11px;
  padding: 7px;
  border-radius: 5px;
  margin-bottom: 3px;
}
</style>
